import { useTranslation } from 'react-i18next';
import { generatePath, useNavigate } from 'react-router-dom';
import { faAngleRight } from '@fortawesome/pro-regular-svg-icons/faAngleRight';
import { faChartNetwork } from '@fortawesome/pro-solid-svg-icons/faChartNetwork';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { WidgetCard } from 'us-react-components/dist/WidgetCard/WidgetCard';
import { useDependencies } from '../../../../../dependencies';
import { Routes } from '../../../../../Routes';
import { Button, ButtonType } from '../../../../Button';

export const ExpandCircleOfTrust = (): JSX.Element => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { stores } = useDependencies();
  const { user } = stores.user;

  const handleClick = (): void => {
    const route = generatePath(Routes.parent.explore, { id: user.id });
    navigate(route);
  }

  return (
    <WidgetCard
      iconName={faChartNetwork}
      iconClasses='text-bubblegum'
      title={t('dashboard.widgets.expandYourCircleOfTrust.title')}
      description={t('dashboard.widgets.expandYourCircleOfTrust.description')}
      hasButton
      buttonComponent={<Button
          buttonType={ButtonType.tertiary}
          onClick={handleClick}>{t('dashboard.widgets.expandYourCircleOfTrust.exploreMoreSocialGroups')}
          <FontAwesomeIcon icon={faAngleRight} className='pl-2 m-[-1px]' />
        </Button>
      }
    />
  );
};
